import { TeamsSenderLayout } from "../TeamsSenderLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSBox, NSBoxEntity, NSBoxString, NSBoxTextArea, NSButtonBlue, NSColumn, NSPanel, NSRow, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { TeamsSenderRouterProps } from "../TeamsSenderRouterProps";
import { useRef } from "react";
import { ProviderRow } from "namirasoft-teams-sender";
import { useParams } from "react-router-dom";
import { TeamsSenderRoutes } from "../TeamsSenderRoutes";
import { FilterItem, FilterItemOperator } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";

export interface ISendPageProps extends NSARouterMakerResult, TeamsSenderRouterProps
{ }

function SendPage(props: ISendPageProps)
{
    let NSBoxEntity_Provider = useRef<NSBoxEntity<ProviderRow>>(null);
    let NSBoxString_TeamID = useRef<NSBoxString>(null);
    let NSBoxString_ChannelID = useRef<NSBoxString>(null);
    let NSBoxTextarea_Message = useRef<NSBoxTextArea>(null);

    let { id } = useParams();

    let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

    return (
        <TeamsSenderLayout {...props}
            action={{
                title: "Send",
                description: "Enter the destination chat_id, message_thread_id and your message to send a message via the selected provider.",
                menus: {}
            }}
        >
            <NSPanel style={{ margin: "0 auto" }}>
                <NSColumn style={{ width: NSBox.width.double }}>
                    <NSRow>
                        <NSBoxEntity<ProviderRow>
                            ref={NSBoxEntity_Provider}
                            title="Provider"
                            required
                            multiple={false}
                            table={namirasoft.teams_sender.tables.provider}
                            getValue={item => item.id}
                            getTitle={item => item.name}
                            getSort={() => null}
                            onLoaded={() =>
                            {
                                if (id)
                                    NSBoxEntity_Provider.current?.setValue(id);
                            }}
                            style={{ width: "100%" }}
                            info={{ link: "https://namirasoft.com/teams-sender/console-guide/send/#field-provider-id" }}
                        />
                    </NSRow>
                    <NSRow>
                        <NSBoxString
                            ref={NSBoxString_TeamID}
                            title="Teams ID"
                            required={false}
                            info={{ link: "https://namirasoft.com/teams-sender/console-guide/send/#field-teams-id" }}
                        />
                        <NSBoxString
                            ref={NSBoxString_ChannelID}
                            title="Channel ID"
                            required={false}
                            info={{ link: "https://namirasoft.com/teams-sender/console-guide/send/#field-channel-id" }}
                        />
                    </NSRow>
                    <NSRow>
                        <NSBoxTextArea
                            ref={NSBoxTextarea_Message}
                            title="Message"
                            required
                            placeholder="Write your Message"
                            style={{ width: "100%" }}
                            info={{ link: "https://namirasoft.com/teams-sender/console-guide/send/#field-message" }}
                        />
                    </NSRow>
                    <NSSpace size={NSSpaceSizeType.MINI} />
                    <NSRow>
                        <NSButtonBlue title="Apply" onClick={{
                            action: (onFinished) =>
                            {
                                try
                                {
                                    let provider_id = NSBoxEntity_Provider.current?.getValueOne();
                                    if (provider_id)
                                    {
                                        let team_id = NSBoxString_TeamID.current?.getValue() ?? null;
                                        let channel_id = NSBoxString_ChannelID.current?.getValue() ?? null;
                                        let message = NSBoxTextarea_Message.current?.getValue() ?? "";
                                        props.servers.teams_sender.teams.Send({ provider_id, team_id, channel_id, message }).then((res) =>
                                        {
                                            props.notifier.onSuccess("A message was sent successfully");

                                            let namirasoft = new NamirasoftMap(props.account.token_manager, props.notifier.onError);
                                            let filters = [new FilterItem(namirasoft.teams_sender.tables.sent, namirasoft.teams_sender.tables.sent.columns.id, false, FilterItemOperator.all.equals, res.id)];
                                            props.url.redirect(TeamsSenderRoutes.SentList, { filters: FilterItem.encode(filters) });
                                            onFinished();
                                        }).catch(onFinished);
                                    }
                                } catch (error)
                                {
                                    props.notifier.onError(error as Error);
                                }
                                onFinished();
                            }
                        }} />
                    </NSRow>
                </NSColumn>
            </NSPanel>
        </TeamsSenderLayout>
    );
}

export default SendPage;